<template>
  <DefaultLayout>
    <div slot="content">
      <!-- FEATURE LIMITED DIALOG-->
      <v-dialog v-model="featureLimitedModal" width="400" persistent>
        <v-card>
          <v-card-title>Feature limited</v-card-title>
          <v-card-text>{{featureLimitedText || featureLimitedDefaultText}}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn tile text color="blue" @click="featureLimitedModal = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- END FEATURE LIMITED DIALOG-->
      <!-- NEW TEMPLATE DIALOG -->
      <v-dialog v-model="profileTemplateDialog" scrollable max-width="900">
        <v-card>
          <v-card-title>{{ modalTitle }}
            <v-spacer></v-spacer>
            <v-btn @click="profileTemplateDialog = false" icon><v-icon>close</v-icon></v-btn>
          </v-card-title>
          <v-card-text>
            <v-form ref="templateForm">
              <v-text-field id="new-profile-template-name" v-bind:value="templateName" v-on:blur="templateName = $event.target.value" label="Template name" type="text" :rules="[v => !!v || 'Please enter template name']" style="max-width: 300px;"></v-text-field>
              <v-expansion-panels accordion multiple class="new-template-options" v-model="templatePanels">
                <!-- Template options panel -->
                <v-expansion-panel>
                  <v-expansion-panel-header :disabled="isEdit" class="font-weight-bold text-uppercase">
                    Template options
                    <template v-slot:actions>
                      <v-icon v-if="isEdit"></v-icon>
                      <v-icon v-if="!isEdit">$expand</v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="py-7">
                    <v-row class="mb-5">
                      <v-col cols="12" sm="6">
                        <v-row class="align-center">
                          <v-col cols="12" sm="7" class="py-0 body-2 font-weight-medium grey--text text--darken-1">Reminder Count</v-col>
                          <v-col cols="12" sm="5" class="py-0">
                            <v-select id="new-profile-template-reminder-count" class="body-2" hide-details dense :items="reminderCount" item-text="id" item-value="id" v-model="selectedReminderCount"></v-select>
                          </v-col>
                        </v-row>
                        <v-row class="align-center">
                          <v-col cols="12" sm="7" class="py-0 body-2 font-weight-medium grey--text text--darken-1">Reminder interval</v-col>
                          <v-col cols="12" sm="5" class="py-0">
                            <v-select id="new-profile-template-reminder-interval" class="body-2" hide-details dense :items="reminderInterval" item-text="text" item-value="id" v-model="selectedReminderInterval"></v-select>
                          </v-col>
                        </v-row>
                        <v-row class="align-center">
                          <v-col cols="12" sm="7" class="py-0 body-2 font-weight-medium grey--text text--darken-1">Approved outcome</v-col>
                          <v-col cols="12" sm="5" class="py-0">
                            <v-select id="new-profile-template-approved-outcome" class="body-2" hide-details dense :items="approvedAutcome" item-text="text" item-value="id" v-model="selectedApprovedAutcome"></v-select>
                          </v-col>
                        </v-row>
                        <v-row class="align-center">
                          <v-col cols="12" sm="7" class="body-2 font-weight-medium grey--text text--darken-1">Notify requester of purge</v-col>
                          <v-col cols="12" sm="5">
                            <v-switch id="new-profile-template-notify-requester-purge" class="mt-0" hide-details color="blue" v-model="notifyRequesterOfPurge"></v-switch>
                          </v-col>
                        </v-row>
                        <v-row class="align-center">
                          <v-col cols="12" sm="7" class="pt-0 body-2 font-weight-medium grey--text text--darken-1">Notify user of purge</v-col>
                          <v-col cols="12" sm="5" class="pt-0">
                            <v-switch id="new-profile-template-notify-user-purge" class="mt-0" hide-details color="blue" v-model="notifyUserOfPurge"></v-switch>
                          </v-col>
                        </v-row>
                        <v-row class="align-center">
                          <v-col cols="12" sm="7" class="py-0 body-2 font-weight-medium grey--text text--darken-1">Custom alias name (optional)</v-col>
                          <v-col cols="12" sm="5" class="py-0">
                            <v-text-field id="new-profile-template-custom-alias-name" class="body-2"
                                          hide-details dense
                                          v-bind:value="customAliasName"
                                          v-on:blur="customAliasName = $event.target.value"
                                          type="text"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row class="align-center">
                          <v-col cols="12" sm="7" class="pt-0 body-2 font-weight-medium grey--text text--darken-1">Enable SMS Notifications</v-col>
                          <v-col cols="12" sm="5" class="pt-0">
                            <v-checkbox id="new-profile-template-enable-sms-notifications" class="mt-0" hide-details color="blue" v-model="smsNotificationsEnabled"></v-checkbox>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-row class="align-center">
                          <v-col cols="12" sm="7" class="py-0 body-2 font-weight-medium grey--text text--darken-1">Declined outcome</v-col>
                          <v-col cols="12" sm="5" class="py-0">
                            <v-select id="new-profile-template-declined-outcome" class="body-2" hide-details dense :items="declinedAutcome" item-text="text" item-value="id" v-model="selectedDeclinedAutcome"></v-select>
                          </v-col>
                        </v-row>
                        <v-row v-if="selectedApprovedAutcome == 7" class="align-center">
                          <v-col cols="12" sm="7" class="py-0 body-2 font-weight-medium grey--text text--darken-1">Approved outcome purge after</v-col>
                          <v-col cols="12" sm="5" class="py-0">
                            <v-select id="new-profile-template-approved-outcome-purging" class="body-2" hide-details dense :items="approvedOutcomePurging" item-text="text" item-value="id" v-model="selectedApprovedOutcomePurging" :disabled="selectedApprovedAutcome !== 7"></v-select>
                          </v-col>
                        </v-row>
                        <v-row class="align-center">
                          <v-col cols="12" sm="7" class="body-2 font-weight-medium grey--text text--darken-1">Notify user of outcome</v-col>
                          <v-col cols="12" sm="5">
                            <v-switch id="new-profile-template-notify-user-outcome" class="mt-0" hide-details color="blue" v-model="notifyUserOfOutcome"></v-switch>
                          </v-col>
                        </v-row>
                        <v-row class="align-center">
                          <v-col cols="12" sm="7" class="py-0 body-2 font-weight-medium grey--text text--darken-1">Included terms (optional)</v-col>
                          <v-col cols="12" sm="5" class="py-0">
                            <v-select id="new-profile-template-included-terms"
                                      class="body-2"
                                      hide-details dense
                                      :items="accountTerms"
                                      item-text="name" item-value="termId"
                                      v-model="selectedTerms"></v-select>
                          </v-col>
                        </v-row>
                        <v-row class="align-center" v-if="organization.purgedRequests">
                          <v-col cols="12" sm="7" class="py-0 body-2 font-weight-medium grey--text text--darken-1">Retain History when purging</v-col>
                          <v-col cols="12" sm="5">
                            <v-switch id="new-profile-template-notify-user-outcome" class="mt-0" hide-details color="blue" v-model="retainHistoryWhenPurge"></v-switch>
                          </v-col>
                        </v-row>
                        <v-row class="align-center" v-if="organization.purgedRequests">
                          <v-col cols="12" sm="7" class="py-0 body-2 font-weight-medium grey--text text--darken-1">Retain Comments when purging</v-col>
                          <v-col cols="12" sm="5">
                            <v-switch id="new-profile-template-notify-user-outcome" class="mt-0" hide-details color="blue" v-model="retainCommentsWhenPurge"></v-switch>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <span class="text-h7">References</span>
                    <v-row>

                      <v-row v-for="item in selectedReferences" :key="item.ordinal" class="align-center pt-3 pb-4">
                        <v-col cols="12" sm="4" class="py-0 pl-6">
                          <v-text-field required hide-details v-bind:value="item.name" v-on:blur="item.name = $event.target.value" label="Name" type="text" :rules="[v => !!v || '']"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" class="py-0">
                          <v-text-field required hide-details v-bind:value="item.value" v-on:blur="item.value = $event.target.value" label="Default value" type="text"></v-text-field>
                        </v-col>
                        <v-col v-if="selectedReferences.length > 1" cols="12" sm="1" class="py-0">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn v-on="on" small icon color="red" @click="removeReference(item.ordinal)"><v-icon small>fal fa-trash-alt</v-icon></v-btn>
                            </template>
                            <span>Remove reference</span>
                          </v-tooltip>
                        </v-col>
                      </v-row>

                    </v-row>
                    <v-btn small dark tile depressed color="blue" class="mt-4" @click="addReference"><v-icon small left dark>fal fa-plus</v-icon>Add reference</v-btn>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <!-- Basic details panel -->
                <v-expansion-panel v-if="!isEdit">
                  <v-expansion-panel-header class="font-weight-bold text-uppercase">Basic details</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col class="pb-0 font-weight-bold">Included items</v-col>
                      <v-col class="pb-0 font-weight-bold">Don't archive on close</v-col>
                      <v-col class="pb-0 font-weight-bold">Mandatory</v-col>
                    </v-row>
                    <v-row v-for="(item, i) in profileItemsBase" :key="item.id">
                      <v-col class="py-0">
                        <v-checkbox hide-details color="blue" :label="item.name" v-model="item.include"></v-checkbox>
                      </v-col>
                      <v-col class="py-0">
                        <v-switch :id="`basic-details-switch-${i}`" hide-details color="blue" :disabled="!item.include" v-model="item.neverArchive"></v-switch>
                      </v-col>
                      <v-col class="py-0">
                        <v-switch :id="`basic-details-switch-${i}`" hide-details color="blue" :disabled="!item.include" v-model="item.mandatory"></v-switch>
                      </v-col>
                    </v-row>
                    <v-divider class="my-4"></v-divider>
                    <v-row v-for="item in customBaseItems" :key="item.id" class="align-center grey lighten-4 pt-3 pb-4">
                      <v-col class="py-0">
                        <v-text-field required hide-details v-bind:value="item.name" v-on:blur="item.name = $event.target.value" label="Name" type="text" :rules="[v => !!v || '']"></v-text-field>
                      </v-col>
                      <v-col class="py-0">
                        <v-select hide-details :items="dataType" item-text="text" item-value="id" v-model="item.dataType" label="Type"></v-select>
                      </v-col>
                      <v-col class="py-0" v-if="item.dataType != 9">
                        <v-checkbox hide-details class="mt-0" color="blue" label="Don't archive on close" v-model="item.neverArchive"></v-checkbox>
                      </v-col>
                      <v-col class="py-0" v-if="item.dataType != 9">
                        <v-checkbox hide-details class="mt-0" color="blue" label="Mandatory" v-model="item.mandatory"></v-checkbox>
                      </v-col>
                      <v-col class="py-0" v-if="item.dataType === 9">
                        <v-text-field required hide-details v-bind:value="item.description" v-on:blur="item.description = $event.target.value" label="HTML text" type="text" :rules="[v => !!v || '']"></v-text-field>
                      </v-col>
                      <v-col class="py-0">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn v-on="on" small icon color="red" @click="removeCustomBase(item.id)"><v-icon small>fal fa-trash-alt</v-icon></v-btn>
                          </template>
                          <span>Remove item</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <v-btn small dark tile depressed color="blue" class="mt-4" @click="addCustomBase"><v-icon small left dark>fal fa-plus</v-icon>Add custom item</v-btn>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <!-- Documents panel -->
                <v-expansion-panel v-if="!isEdit">
                  <v-expansion-panel-header class="font-weight-bold text-uppercase">Documents</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col class="pb-0 font-weight-bold">Included items</v-col>
                      <v-col class="pb-0 font-weight-bold">Don't archive on close</v-col>
                      <v-col class="pb-0 font-weight-bold">Mandatory</v-col>
                    </v-row>
                    <v-row v-for="(item, i) in profileItemsDocs" :key="item.id">
                      <v-col class="py-0">
                        <v-checkbox hide-details color="blue" :label="item.name" v-model="item.include"></v-checkbox>
                      </v-col>
                      <v-col class="py-0">
                        <v-switch :id="`basic-details-switch-${i}`" hide-details color="blue" :disabled="!item.include" v-model="item.neverArchive"></v-switch>
                      </v-col>
                      <v-col class="py-0">
                        <v-switch :id="`basic-details-switch-${i}`" hide-details color="blue" :disabled="!item.include" v-model="item.mandatory"></v-switch>
                      </v-col>
                    </v-row>
                    <v-divider class="my-4"></v-divider>
                    <v-row v-for="item in customDocumentItems" :key="item.id" class="align-center grey lighten-4 pt-3 pb-4">
                      <v-col class="py-0">
                        <v-text-field required hide-details v-bind:value="item.name" v-on:blur="item.name = $event.target.value" label="Name" type="text" :rules="[v => !!v || '']"></v-text-field>
                      </v-col>
                      <v-col class="py-0">
                        <v-text-field hide-details v-bind:value="item.description" v-on:blur="item.description = $event.target.value" label="Instruction for app user" type="text" ></v-text-field>
                      </v-col>
                      <v-col class="py-0">
                        <v-checkbox hide-details class="mt-0" color="blue" label="Don't archive on close" v-model="item.neverArchive"></v-checkbox>
                      </v-col>
                      <v-col class="py-0">
                        <v-checkbox hide-details class="mt-0" color="blue" label="Mandatory" v-model="item.mandatory"></v-checkbox>
                      </v-col>
                      <v-col cols="12" sm="1" class="py-0">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn v-on="on" small icon color="red" @click="removeCustomDoc(item.id)"><v-icon small>fal fa-trash-alt</v-icon></v-btn>
                          </template>
                          <span>Remove item</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <v-btn small dark tile depressed color="blue" class="mt-4" @click="addCustomDoc"><v-icon small left dark>fal fa-plus</v-icon>Add custom item</v-btn>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <!-- Forms panel -->
                <v-expansion-panel v-if="!isEdit">
                  <v-expansion-panel-header class="font-weight-bold text-uppercase">Forms</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col class="pb-0 font-weight-bold">Included items</v-col>
                      <v-col class="pb-0 font-weight-bold">Don't archive on close</v-col>
                    </v-row>
                    <v-row v-for="(item, i) in profileItemsForms" :key="item.id">
                      <v-col cols="12" sm="6" class="py-0">
                        <v-checkbox hide-details color="blue" :label="item.name" v-model="item.include"></v-checkbox>
                      </v-col>
                      <v-col cols="12" sm="6" class="py-0">
                        <v-switch :id="`basic-details-switch-${i}`" hide-details color="blue" :disabled="!item.include" v-model="item.neverArchive"></v-switch>
                      </v-col>
                    </v-row>
                    <v-row v-for="item in customFormItems" :key="item.id" class="align-center grey lighten-4 pt-3 pb-4 mt-2">
                      <v-col cols="12" sm="3" class="py-0">
                        <v-text-field required hide-details v-bind:value="item.name" v-on:blur="item.name = $event.target.value" label="Name" type="text" :rules="[v => !!v || '']"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4" class="py-0">
                        <v-text-field hide-details v-bind:value="item.description" v-on:blur="item.description = $event.target.value" label="Instruction for app user" type="text" ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4" class="py-0">
                        <v-checkbox hide-details class="mt-0" color="blue" label="Don't archive on close" v-model="item.neverArchive"></v-checkbox>
                      </v-col>
                      <v-col cols="12" sm="1" class="py-0">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn v-on="on" small icon color="red" @click="removeCustomForm(item.id)"><v-icon small>fal fa-trash-alt</v-icon></v-btn>
                          </template>
                          <span>Remove item</span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="1" sm="12" class="py-0">
                        <v-row class="py-2 px-3 font-weight-bold">Sections:</v-row>
                      </v-col>
                      <template v-for="section in item.sections" class="grey lighten-4 px-3 pb-3 mb-2">
                        <v-col cols="12" sm="11" class="py-0" :key="section.id">
                          <v-text-field v-model="section.name" label="Section Name" type="text" :ref="section.name" :rules="[v => !!v || '']"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="1" class="py-0 text-right" :key="section.id + '-remove'">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn v-on="on" small icon color="red" @click="removeSection(item, section.id)"><v-icon small>fal fa-trash-alt</v-icon></v-btn>
                            </template>
                            <span>Remove section</span>
                          </v-tooltip>
                        </v-col>
                        <template v-for="sectionItem in section.sectionItems">
                          <v-col cols="12" sm="5" class="py-0 px-3" :key="sectionItem.id"><v-select dense :items="dataType" item-text="text" item-value="id" v-model="sectionItem.dataType" label="Item Type"></v-select></v-col>
                          <v-col cols="12" sm="6" class="py-0 px-3" :key="sectionItem.id + '1'"><v-textarea outlined rows="2" auto-grow v-model="sectionItem.name" label="Name" :rules="[v => !!v || '']"></v-textarea></v-col>
                          <v-col cols="12" sm="1" class="py-0 text-right" :key="sectionItem.id + '-remove'">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-btn v-on="on" small icon color="red" @click="removeItem(section, sectionItem.id)"><v-icon small>fal fa-trash-alt</v-icon></v-btn>
                              </template>
                              <span>Remove field</span>
                            </v-tooltip>
                          </v-col>
                        </template>
                        <v-col cols="1" sm="12" class="py-0 pb-1" :key="section.name">
                          <v-btn small tile dark depressed color="blue" @click="addItem(section)">Add Item</v-btn>
                        </v-col>
                      </template>
                      <v-col cols="1" sm="12" class="py-0">
                        <v-btn small tile dark depressed color="blue" @click="addSection(item)">Add Section</v-btn>
                      </v-col>
                      <v-divider class="my-4"></v-divider>
                    </v-row>
                    <v-btn small dark tile depressed color="blue" class="mt-4" @click="addCustomForm"><v-icon small left dark>fal fa-plus</v-icon>Add custom form</v-btn>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <!-- Signzy flows panel -->
                <v-expansion-panel>
                  <v-expansion-panel-header class="font-weight-bold text-uppercase">Verify your ID Flow</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <template v-if="signzyFlowItems.length">
                      <v-row>
                        <v-col cols="12" sm="4" class="pb-0 font-weight-bold">Flow</v-col>
                        <v-col cols="12" sm="4" class="pb-0 font-weight-bold">Description</v-col>
                        <v-col cols="12" sm="2" class="pb-0 font-weight-bold">Don't archive on close</v-col>
                        <v-col cols="12" sm="2" class="pb-0 font-weight-bold">Mandatory</v-col>
                      </v-row>
                      <v-row v-for="flow in signzyFlowItems" :key="flow.id" class="align-center">
                        <v-col cols="12" sm="4" class="py-0">
                          <v-checkbox
                            hide-details
                            color="blue"
                            :label="flow.flowId ? `${flow.name} (${flow.flowId})` : flow.name"
                            v-model="flow.include">
                          </v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="4" class="py-0">
                          <v-text-field
                            hide-details
                            label="Description"
                            :disabled="!flow.include"
                            v-model="flow.description">
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2" class="py-0">
                          <v-checkbox
                            hide-details
                            class="mt-0"
                            color="blue"
                            :disabled="!flow.include"
                            label="Don't archive"
                            v-model="flow.neverArchive">
                          </v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="2" class="py-0">
                          <v-checkbox
                            hide-details
                            class="mt-0"
                            color="blue"
                            :disabled="!flow.include"
                            label="Mandatory"
                            v-model="flow.mandatory">
                          </v-checkbox>
                        </v-col>
                      </v-row>
                    </template>
                    <div v-else class="caption grey--text">
                      No Verify your ID Flow available. Configure flows under Integrations.
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel v-if="!isEdit && customEmailTemplatesList.length">
                  <v-expansion-panel-header class="font-weight-bold text-uppercase">Custom email templates</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row v-for="template in customEmailTemplatesList" :key="template.id">
                      <v-col cols="12" sm="5" class="pb-0">{{ template.name }}</v-col>
                      <v-col cols="12" sm="4" class="pb-0">
                        <v-select class="body-2"
                                  hide-details dense
                                  :items="template.templates"
                                  item-text="name" item-value="id"
                                  v-model="template.selectedEmailTemplate">
                        </v-select>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn tile text color="blue" @click="profileTemplateDialog = false">Close</v-btn>
            <v-btn id="new-profile-template-save" tile dark depressed color="blue" @click="saveProfileTemplate">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- END NEW TEMPLATE DIALOG -->

      <!-- CONFIRM DELETE TEMPLATE DIALOG -->
      <v-dialog v-model="confirmDeleteTemplateDialog" persistent max-width="425">
        <v-card>
          <v-card-text class="body-1 pt-5">Are you sure you want to delete template <span class="whitespace-nowrap">{{templateToDelete.name}}</span>?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn tile text @click="confirmDeleteTemplateDialog = false">Close</v-btn>
            <v-btn tile dark depressed color="red" @click="deleteProfileTemplate">Delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- END CONFIRM DELETE TEMPLATE DIALOG -->

      <v-dialog v-model="emailTemplatePreview" width="900">
        <v-card>
          <v-card-title>Email template</v-card-title>
          <v-card-text>
            <p v-html="emailTemplatePreviewBody"></p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn tile text color="blue" @click="emailTemplatePreview = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <div class="d-flex align-center mb-3">
        <div class="title" @click="updateProfileTemplates">Templates</div>
        <v-spacer></v-spacer>
        <v-btn id="add-profile-template" tile small dark depressed color="blue" @click="addProfileTemplate"><v-icon small left dark>fal fa-pencil-ruler</v-icon>New template</v-btn>
      </div>
      <v-divider class="mb-5"></v-divider>

      <v-card v-for="t in preparedTemplates" :key="t.id" class="mb-10" style="border-radius: 20px !important;">
        <v-card-title>
          {{ t.name }}
          <v-spacer></v-spacer>
          <p v-if="$store.getters.isSystemAdmin" class="mb-0 text--disabled">{{ t.id }}</p>
          <v-btn v-if="$store.getters.isSystemAdmin" tile small text color="grey" @click="toClipboard(t.id)"><v-icon small dark class="mr-2">far fa-copy</v-icon>Copy ID to clipboard</v-btn>
          <v-btn tile small text color="red" @click="confirmDeleteProfileTemplate(t)"><v-icon small dark class="mr-2">fal fa-trash-alt</v-icon>Delete</v-btn>
          <v-btn tile small text color="green" @click="copyTemplate(t)"><v-icon small dark class="mr-2">far fa-copy</v-icon>Copy</v-btn>
          <v-btn tile small text color="blue" @click="editProfileTemplate(t)"><v-icon small dark class="mr-2">fal fa-cog</v-icon>Options</v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-10">
          <v-row>
            <v-col sm="12" md="6" lg="3" class="py-0">
              <v-row class="pb-1">
                <v-col sm="6" class="py-0 body-2 font-weight-medium">Reminder count</v-col>
                <v-col sm="6" class="py-0 body-2">{{ t.reminderCount }}</v-col>
              </v-row>
              <v-row class="pb-1">
                <v-col sm="6" class="py-0 body-2 font-weight-medium">Reminder interval</v-col>
                <v-col sm="6" class="py-0 body-2">{{ getItemnameById(reminderInterval, t.reminderInterval) }}</v-col>
              </v-row>
              <v-row class="pb-1">
                <v-col sm="6" class="py-0 body-2 font-weight-medium">Approved outcome</v-col>
                <v-col sm="6" class="py-0 body-2">{{ getItemnameById(approvedAutcome, t.approvedStatus) }}</v-col>
              </v-row>
            </v-col>
            <v-col sm="12" md="6" lg="3" class="py-0">
              <v-row class="pb-1">
                <v-col sm="6" class="py-0 body-2 font-weight-medium">Declined outcome</v-col>
                <v-col sm="6" class="py-0 body-2">{{ getItemnameById(declinedAutcome, t.declinedStatus) }}</v-col>
              </v-row>
              <v-row v-if="t.approvedStatus == 7" class="pb-1">
                <v-col sm="6" class="py-0 body-2 font-weight-medium">Approved outcome purge after</v-col>
                <v-col sm="6" class="py-0 body-2">{{ getItemnameById(approvedOutcomePurging, t.purgeAfterDays) }}</v-col>
              </v-row>
              <v-row class="pb-1">
                <v-col sm="6" class="py-0 body-2 font-weight-medium">Notify user of outcome</v-col>
                <v-col sm="6" class="py-0 body-2">{{ t.notifyUserOfOutcome ? 'Yes' : 'No' }}</v-col>
              </v-row>
            </v-col>
            <v-col sm="12" md="6" lg="3" class="py-0">
              <v-row class="pb-1">
                <v-col sm="6" class="py-0 body-2 font-weight-medium">Notify requester of purge</v-col>
                <v-col sm="6" class="py-0 body-2">{{ t.notifyRequesterAfterPurge ? 'Yes' : 'No' }}</v-col>
              </v-row>
              <v-row class="pb-1">
                <v-col sm="6" class="py-0 body-2 font-weight-medium">Notify user of purge</v-col>
                <v-col sm="6" class="py-0 body-2">{{ t.notifyRequestedAfterPurge ? 'Yes' : 'No' }}</v-col>
              </v-row>
              <v-row class="pb-1">
                <v-col sm="6" class="py-0 body-2 font-weight-medium">Use custom alias</v-col>
                <v-col sm="6" class="py-0 body-2">{{ t.useCustomAlias ? 'Yes' : 'No' }}</v-col>
              </v-row>
            </v-col>
            <v-col sm="12" md="6" lg="3" class="py-0">
              <v-row class="pb-1">
                <v-col sm="6" class="py-0 body-2 font-weight-medium">Custom alias name</v-col>
                <v-col sm="6" class="py-0 body-2">{{ t.customAliasName ? t.customAliasName : 'No' }}</v-col>
              </v-row>
              <v-row class="pb-1">
                <v-col sm="6" class="py-0 body-2 font-weight-medium">Included terms</v-col>
                <v-col sm="6" class="py-0 body-2">{{ getTermsName(t.termsId) }}</v-col>
              </v-row>
            </v-col>
          </v-row>
          <!-- TEMPLATE Requested basic details -->
          <template v-if="t.basicItems && t.basicItems.length">
            <div class="subtitle-1 font-weight-bold mt-7">Requested basic details</div>
            <v-row class="mt-0">
              <v-col sm="12" md="6" lg="3" class="py-0" v-for="(detail, i) in t.basicItems" :key="`${t.id}-${detail.name}-${i}`">
                <v-tooltip bottom v-if="detail.neverArchive">
                  <template v-slot:activator="{ on }">
                    <v-icon small v-on="on" color="orange" class="mr-1">fal fa-exclamation-circle</v-icon>
                  </template>
                  <span>Item set to never archive</span>
                </v-tooltip>
                <v-tooltip bottom v-if="detail.mandatory">
                  <template v-slot:activator="{ on }">
                    <v-icon small v-on="on" color="red" class="mr-1">fas fa-exclamation</v-icon>
                  </template>
                  <span>Mandatory item</span>
                </v-tooltip>
                <!-- If we have description for requested item -->
                <v-tooltip top v-if="detail.description">
                  <template v-slot:activator="{ on }">
                    <span class="caption" v-on="on">{{ detail.name }}</span>
                  </template>
                  <span class="body-2">{{ detail.description }}</span>
                </v-tooltip>
                <!-- Else we do not have description for requested item -->
                <span v-else class="body-2">{{ detail.name }}</span>
              </v-col>
            </v-row>
          </template>
          <!-- END TEMPLATE Requested basic details -->
          <!-- TEMPLATE Requested files -->
          <template v-if="t.fileItems && t.fileItems.length">
            <div class="subtitle-1 font-weight-bold mt-7">Requested files</div>
            <v-row class="mt-0">
              <v-col sm="12" md="6" lg="3" class="py-0" v-for="(detail, i) in t.fileItems" :key="`${t.id}-${detail.name}-${i}`">
                <v-tooltip bottom v-if="detail.neverArchive">
                  <template v-slot:activator="{ on }">
                    <v-icon small v-on="on" color="orange" class="mr-1">fal fa-exclamation-circle</v-icon>
                  </template>
                  <span>Item set to never archive</span>
                </v-tooltip>
                <v-tooltip bottom v-if="detail.mandatory">
                  <template v-slot:activator="{ on }">
                    <v-icon small v-on="on" color="red" class="mr-1">fas fa-exclamation</v-icon>
                  </template>
                  <span>Mandatory item</span>
                </v-tooltip>
                <!-- If we have description for requested item -->
                <v-tooltip top v-if="detail.description">
                  <template v-slot:activator="{ on }">
                    <span class="caption" v-on="on">{{ detail.name }}</span>
                  </template>
                  <span>{{ detail.description }}</span>
                </v-tooltip>
                <!-- Else we do not have description for requested item -->
                <span v-else class="caption">{{ detail.name }}</span>
              </v-col>
            </v-row>
          </template>
          <!-- END TEMPLATE Requested files -->
          <!-- TEMPLATE Requested forms -->
          <template v-if="t.formItems && t.formItems.length">
            <div class="subtitle-1 font-weight-bold mt-7">Requested forms</div>
            <v-row class="mt-0">
              <v-col sm="12" md="6" lg="3" class="py-0" v-for="(detail, i) in t.formItems" :key="`${t.id}-${detail.name}-${i}`">
                <v-tooltip bottom v-if="detail.neverArchive">
                  <template v-slot:activator="{ on }">
                    <v-icon small v-on="on" color="orange" class="mr-1">fal fa-exclamation-circle</v-icon>
                  </template>
                  <span>Item set to never archive</span>
                </v-tooltip>
                <!-- If we have description for requested item -->
                <v-tooltip top v-if="detail.description">
                  <template v-slot:activator="{ on }">
                    <span class="caption" v-on="on">{{ detail.name }}</span>
                  </template>
                  <span>{{ detail.description }}</span>
                </v-tooltip>
                <!-- Else we do not have description for requested item -->
                <span v-else class="caption">{{ detail.name }}</span>
              </v-col>
            </v-row>
          </template>
          <!-- END TEMPLATE Requested forms -->
          <!-- TEMPLATE Requested other items -->
          <template v-if="t.otherItems && t.otherItems.length">
            <div class="subtitle-1 font-weight-bold mt-3">Requested other items</div>
            <v-row>
              <v-col sm="12" md="6" lg="3" class="py-0" v-for="(detail, i) in t.otherItems" :key="`${t.id}-${detail.name}-${i}`">
                <v-tooltip bottom v-if="detail.neverArchive">
                  <template v-slot:activator="{ on }">
                    <v-icon small v-on="on" color="orange" class="mr-1">fal fa-exclamation-circle</v-icon>
                  </template>
                  <span>Item set to never archive</span>
                </v-tooltip>
                <!-- If we have description for requested item -->
                <v-tooltip top v-if="detail.description">
                  <template v-slot:activator="{ on }">
                    <span class="caption" v-on="on">{{ detail.name }}</span>
                  </template>
                  <span>{{ detail.description }}</span>
                </v-tooltip>
                <!-- Else we do not have description for requested item -->
                <span v-else class="caption">{{ detail.name }}</span>
              </v-col>
            </v-row>
          </template>
          <!-- TEMPLATE custom emails -->
          <template v-if="t.customEmailTemplates && t.customEmailTemplates.length && anyTemplateExist(t.customEmailTemplates)">
            <div class="subtitle-1 font-weight-bold mt-3">Custom email templates</div>
            <v-row>
              <v-col sm="12" md="6" lg="3" class="py-0" v-for="(detail, i) in t.customEmailTemplates" :key="`${t.id}-${detail.templateId}-${i}`">
                <div v-if="templateExist(detail.type, detail.templateId)">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon @click="showTemplate(detail.type, detail.templateId)" small v-on="on" color="primary" class="mr-1">fas fa-eye</v-icon>
                    </template>
                    <span>Preview template</span>
                  </v-tooltip>
                  <span class="caption">{{ getEmailTemplateName(detail.type, detail.templateId) }}</span>
                </div>
              </v-col>
            </v-row>
          </template>
          <!-- END TEMPLATE custom emails -->
        </v-card-text>
      </v-card>
      <div v-if="!preparedTemplates.length" class="text-center pt-12 mt-12 headline font-weight-bold grey--text">
        No templates created
      </div>
    </div>
  </DefaultLayout>
</template>

<script>
import uuidv4 from 'uuid/v4';
import { mapState } from 'vuex';
import {
  CHECK_ORGANIZATIONS,
  GET_TEMPLATES,
  CREATE_TEMPLATE,
  GET_PROFILE_ITEMS,
  EDIT_TEMPLATE,
  DELETE_TEMPLATE,
  GET_ACCOUNT_CUSTOM_EMAIL_TEMPLATES,
  GET_SIGNZY_FLOWS,
} from '@/store/actions.type';
import DefaultLayout from '@/layouts/DefaultLayout';
import { customizableEmailTemplates } from '@/helpers/constants';

export default {
  name: 'profile-templates',
  components: {
    DefaultLayout,
  },
  data() {
    return {
      featureLimitedModal: false,
      featureLimitedText: '',
      featureLimitedDefaultText: 'To enable this feature, you need to upgrade your price plan.',
      templatePanels: [0],
      profileTemplateDialog: false,
      confirmDeleteTemplateDialog: false,
      templateToDelete: {name: ''},
      modalTitle: 'New profile template',
      templateId: '',
      templateName: '',
      reminderCount: [{ id: 0 }, { id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }, { id: 6 }, { id: 7 }],
      selectedReferences: [],
      selectedReminderCount: 1,
      reminderInterval: [
        { id: 12, text: '12 Hours' },
        { id: 24, text: '24 Hours' },
        { id: 36, text: '36 Hours' },
        { id: 48, text: '48 Hours' },
        { id: 72, text: '72 Hours' },
        { id: 168, text: '1 Week' },
        { id: 336, text: '2 Weeks' },
      ],
      selectedReminderInterval: 12,
      approvedAutcome: [{ id: 6, text: 'Archive' }, { id: 7, text: 'Purge' }],
      selectedApprovedAutcome: 6,
      declinedAutcome: [{ id: 6, text: 'Archive' }, { id: 7, text: 'Purge (24 Hours)' }],
      selectedDeclinedAutcome: 6,
      approvedOutcomePurging: [
        { id: 0, text: '24 Hours' },
        { id: 30, text: 'Scheduled: 1M' },
        { id: 90, text: 'Scheduled: 3M' },
        { id: 180, text: 'Scheduled: 6M' },
        { id: 270, text: 'Scheduled: 9M' },
        { id: 365, text: 'Scheduled: 12M' },
        { id: 547, text: 'Scheduled: 18M' },
        { id: 730, text: 'Scheduled: 2Y' },
        { id: 1095, text: 'Scheduled: 3Y' },
      ],
      selectedApprovedOutcomePurging: 0,
      selectedTerms: 'None',
      useCustomAlias: false,
      customAliasName: '',
      notifyUserOfOutcome: false,
      retainHistoryWhenPurge: false,
      retainCommentsWhenPurge: false,
      notifyRequesterOfPurge: false,
      notifyUserOfPurge: false,
      disableSMSNotifications: false,
      customEmailTemplates: [],
      customEmailTemplatesList: [],
      model: null,
      selected_items: [],
      never_archive: [],
      profileItems: [],
      profileItemsBase: [],
      profileItemsDocs: [],
      profileItemsForms: [],
      eSignTemplates: [],
      itemTypes: { 1: 'Scalar', 2: 'Scanned', 3: 'Imported', 4: 'Template', 5: 'DocuSign', 6: 'Agreement' },
      isEdit: false,
      pagination: {
        rowsPerPage: 8,
      },
      paginationItems: {
        rowsPerPage: 8,
      },
      customBaseItems: [],
      dataType: [
        { id: 1, text: 'Text' },
        { id: 2, text: 'Numeric' },
        { id: 3, text: 'Date' },
        { id: 4, text: 'Email' },
        { id: 5, text: 'Mobile number' },
        { id: 6, text: 'Multiple line text' },
        { id: 7, text: 'Yes/No option' },
        { id: 9, text: 'Link' },
      ],
      customDocumentItems: [],
      customFormItems: [],
      signzyFlowItems: [],
      emailTemplatePreview: false,
      emailTemplatePreviewBody: null,
    };
  },
  watch: {
    customAliasName(val) {
      this.useCustomAlias = !!val;
    },
    featureLimitedModal(val) {
      if (!val) {
        this.featureLimitedText = '';
      }
    },
  },
  computed: {
    ...mapState({ organization: state => state.organizations.userSelectedOrganization }),
    ...mapState({ account: state => state.organizations.userSelectedAccount }),
    ...mapState({ templates: state => state.profileTemplates.selectedAccountTemplates }),
    ...mapState({ limitations: state => state.organizations.userSelectedOrganization.limitations }),
    smsNotificationsEnabled: {
      get() {
        return this.disableSMSNotifications;
      },
      set(value) {
        this.disableSMSNotifications = value;
      },
    },
		accountTerms() {
			const terms = ['None'];
      if (this.account && this.account.terms && this.account.terms.length) {
          this.account.terms.forEach(term => {
            if(!term.deleted){
              terms.push(term)
            }
          }
        );
      }
			return terms;
		},
    preparedTemplates() {
      const preparedTemplates = [];
      if(this.templates){
        this.templates.forEach(template => {
          const newTemplate = { ... template };
          delete newTemplate.items;
          newTemplate.basicItems = [];
          newTemplate.fileItems = [];
          newTemplate.formItems = [];
          newTemplate.docusignItems = [];
          newTemplate.otherItems = [];

          template.items.forEach(item => {
            if (item.itemType === 1) {
              newTemplate.basicItems.push(item);
            } else if (item.itemType === 2) {
              newTemplate.fileItems.push(item);
            } else if (item.itemType === 4) {
              newTemplate.formItems.push(item);
            } else if (item.itemType === 5) {
              newTemplate.docusignItems.push(item);
            } else {
              newTemplate.otherItems.push(item);
            }
          });
          preparedTemplates.push(newTemplate);
        });
      }
      return preparedTemplates;
    },
  },
  methods: {
    toClipboard(text) {
        var input = document.createElement('input');
        input.setAttribute('value', text);
        document.body.appendChild(input);
        input.select();
        var result = document.execCommand('copy');
        document.body.removeChild(input);
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Copied to clipboard!',
        });
        return result;
    },
    showTemplate(type, id){
      this.emailTemplatePreview = true
      var temp = this.customEmailTemplatesList.find(x => x.type === type);
      var tmp = temp.templates.find(x => x.id === id);
      this.emailTemplatePreviewBody = tmp.body
    },
    anyTemplateExist(emailTemplates){
      return emailTemplates.some(x => this.templateExist(x.type, x.templateId))
    },
    templateExist(type, id){
      if(!this.customEmailTemplatesList){
        return false;
      }
      var temp = this.customEmailTemplatesList.find(x => x.type === type);
      if(!temp){
        return false;
      }
      var tmp = temp.templates.find(x => x.id === id);
      if(tmp){
        return true;
      }
      return false;
    },
    getEmailTemplateName(type, id){
      var temp = this.customEmailTemplatesList.find(x => x.type === type);
      var tmp = temp.templates.find(x => x.id === id);
      if(tmp){
        return `${temp.name}: ${tmp.name}`
      }
      return `${temp.name}: -- Template deleted --`;
    },
    async getCustomEmailTemplates() {
      try {
        const customTemplates = await this.$store.dispatch(GET_ACCOUNT_CUSTOM_EMAIL_TEMPLATES, this.organization.id);
        this.customEmailTemplates = customTemplates.list;
        this.prepareCustomEmailTemplates();
      } catch(err) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Error getting custom email templates. Please contact support@planetverify.com',
        });
      }
    },
    prepareCustomEmailTemplates() {
      if(!this.customEmailTemplates){
        this.customEmailTemplatesList = []
        return
      }
      const preparedEmailTemplates = [];
      for (let key in customizableEmailTemplates) {
        const template = {
          type: customizableEmailTemplates[key].type,
          name: customizableEmailTemplates[key].name,
          templates: [{ name: 'Default template', id: 0 }],
          selectedEmailTemplate: 0,
        };
        this.customEmailTemplates.forEach(t => {
          if (t.type === template.type) {
            template.templates.push(t);
          }
        });
        preparedEmailTemplates.push(template);
      }
      this.customEmailTemplatesList = preparedEmailTemplates;
    },
    addReference() {
      let maxOrd = Math.max.apply(Math, this.selectedReferences.map(function(o) { return o.ordinal; }))
      this.selectedReferences.push({ name: 'Reference ' + (maxOrd+1), ordinal: maxOrd+1, value: '' });
    },
    removeReference(id) {
      this.selectedReferences = this.selectedReferences.filter(x => x.ordinal != id);
    },
    addCustomBase() {
      this.customBaseItems.push({ id: uuidv4(), name: '', description: '', dataType: 1, neverArchive: false, ordinal: this.customBaseItems.length + 50, mandatory: false });
    },
    removeCustomBase(id) {
      this.customBaseItems = this.customBaseItems.filter(x => x.id != id);
    },
    addCustomDoc() {
      this.customDocumentItems.push({ id: uuidv4(), name: '', description: '', neverArchive: false, ordinal: this.customDocumentItems.length + 60, mandatory: false });
    },
    removeCustomDoc(id) {
      this.customDocumentItems = this.customDocumentItems.filter(x => x.id != id);
    },
    addCustomForm() {
      this.customFormItems.push({ id: uuidv4(), name: '', description: '', neverArchive: false, ordinal: this.customFormItems.length + 70, sections: [] });
    },
    removeCustomForm(id) {
      this.customFormItems = this.customFormItems.filter(x => x.id != id);
    },
    addSection(item) {
      item.sections.push({ id: uuidv4(), name: '', sectionItems: [ { id: uuidv4(), name: '', dataType: 1 } ], ordinal: item.sections.length + 1 });
    },
    removeSection(item, sectionId) {
      item.sections = item.sections.filter(section => section.id !== sectionId);
      item.sections.forEach((section, index) => {
        section.ordinal = index + 1;
      });
    },
    addItem(section) {
      section.sectionItems.push({ id: uuidv4(), name: '', dataType: 1, ordinal: section.sectionItems.length + 1 });
    },
    removeItem(section, itemId) {
      section.sectionItems = section.sectionItems.filter(item => item.id !== itemId);
      section.sectionItems.forEach((item, index) => {
        item.ordinal = index + 1;
      });
    },
    async loadSignzyFlows() {
      try {
        const response = await this.$store.dispatch(GET_SIGNZY_FLOWS);
        this.signzyFlowItems = this.normalizeSignzyFlows(response);
      } catch (err) {
        this.signzyFlowItems = [];
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Unable to load Verify your ID Flow. Please contact support@planetverify.com',
        });
      }
    },
    normalizeSignzyFlows(apiResponse) {
      const flows = Array.isArray(apiResponse?.flows) ? apiResponse.flows : apiResponse || [];
      if (!Array.isArray(flows)) {
        return [];
      }
      return flows.map((flow, index) => {
        const identifier = flow.flowId || flow.id || uuidv4();
        return {
          id: identifier,
          flowId: flow.flowId || flow.id || '',
          name: flow.flowName || flow.name || 'Untitled flow',
          description: flow.description || '',
          defaultDescription: flow.description || '',
          include: false,
          neverArchive: false,
          mandatory: false,
          ordinal: typeof flow.ordinal === 'number' ? flow.ordinal : index,
        };
      });
    },
    resetSignzyFlows() {
      if (!this.signzyFlowItems.length) {
        return;
      }
      this.signzyFlowItems = this.signzyFlowItems.map(flow => ({
        ...flow,
        include: false,
        neverArchive: false,
        mandatory: false,
        description: flow.defaultDescription || '',
      }));
    },
    applySignzyFlows(templateFlows) {
      if (!Array.isArray(templateFlows) || !templateFlows.length) {
        return;
      }
      templateFlows.forEach(flow => {
        const matched = this.signzyFlowItems.find(item => item.id === flow.id || item.flowId === flow.id);
        if (matched) {
          matched.include = true;
          matched.description = flow.description || matched.description;
          matched.neverArchive = !!flow.neverArchive;
          matched.mandatory = !!flow.mandatory;
          matched.ordinal = typeof flow.ordinal === 'number' ? flow.ordinal : matched.ordinal;
        } else {
          const identifier = flow.id || flow.flowId || uuidv4();
          this.signzyFlowItems.push({
            id: identifier,
            flowId: flow.flowId || flow.id || identifier,
            name: flow.name || flow.flowName || 'Untitled flow',
            description: flow.description || '',
            defaultDescription: flow.description || '',
            include: true,
            neverArchive: !!flow.neverArchive,
            mandatory: !!flow.mandatory,
            ordinal: typeof flow.ordinal === 'number' ? flow.ordinal : this.signzyFlowItems.length,
          });
        }
      });
    },
    getSelectedSignzyFlows() {
      return this.signzyFlowItems
        .filter(flow => flow.include)
        .map((flow, index) => ({
          id: flow.id,
          name: flow.name,
          description: flow.description,
          ordinal: typeof flow.ordinal === 'number' ? flow.ordinal : index,
          neverArchive: !!flow.neverArchive,
          mandatory: !!flow.mandatory,
        }));
    },
    setSignzyFlowSelections(flows) {
      this.resetSignzyFlows();
      if (Array.isArray(flows) && flows.length) {
        this.applySignzyFlows(flows);
      }
    },
    getItemnameById(arr, id) {
      const i = arr.find(x => x.id == id);
      if (!i) {
        return 'NULL';
      }
      return i.text;
    },
    async updateProfileTemplates() {
      try {
        await this.$store.dispatch(GET_TEMPLATES, this.account.accountId);
      } catch (err) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Error getting templates. Please contact support@planetverify.com',
        });
      }
    },
    updateprofileItemsList() {
      this.$store.dispatch(GET_PROFILE_ITEMS).then(response => {
        response.forEach(el => {
          el.include = false;
          el.neverArchive = false;
        });
        this.profileItems = response;
        this.profileItemsBase = response.filter(x => x.itemType === 1 );
        this.profileItemsDocs = response.filter(x => x.itemType === 2 );
        this.profileItemsForms = response.filter( x => x.itemType === 4 && x.name.includes('Medical') );
      }, () => {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Something went wrong - please contact support@planetverify.com',
        });
      })
    },
    getTermsName(termId) {
      if(!this.account.terms){
        return 'No';
      }
      const term = this.account.terms.find(x => x.termId == termId);
      return term ? term.name : 'No';
    },
    async saveProfileTemplate() {
      if (!this.$refs.templateForm.validate()) {
        return;
      }

      if (this.isEdit) {
        // UPDATING EXISTING TEMPLATE
        const customSignzyFlows = this.getSelectedSignzyFlows();
        const updatedTemplate = {
          id: this.templateId,
          name: this.templateName,
          reminderCount: this.selectedReminderCount,
          references: this.selectedReferences,
          reminderInterval: this.selectedReminderInterval,
          approvedStatus: this.selectedApprovedAutcome,
          declinedStatus: this.selectedDeclinedAutcome,
          purgeAfterDays: this.selectedApprovedOutcomePurging,
          notifyUserOfOutcome: this.notifyUserOfOutcome,
          retainHistoryWhenPurge: this.retainHistoryWhenPurge,
          retainCommentsWhenPurge: this.retainCommentsWhenPurge,
          notifyRequesterAfterPurge: this.notifyRequesterOfPurge,
          notifyRequestedAfterPurge: this.notifyUserOfPurge,
          useCustomAlias: this.useCustomAlias,
          customAliasName: this.customAliasName,
          disableSMSNotifications: this.disableSMSNotifications,
          selectedItems: [],
          customSignzyFlows,
        };
        if (this.customEmailTemplates && this.customEmailTemplates.length) {
          updatedTemplate.customEmailTemplates = this.customEmailTemplates;
        }
        if (this.selectedTerms && this.selectedTerms !== 'None') {
          updatedTemplate.termsId = this.selectedTerms;
        }

        try {
          await this.$store.dispatch(EDIT_TEMPLATE, updatedTemplate);
          this.$notify({
            type: 'success',
            title: 'Success',
            text: 'Profile template updated',
          });
          this.templates.forEach(obj => {
            if (obj.id === updatedTemplate.id) {
              obj.name = updatedTemplate.name;
              obj.reminderCount = updatedTemplate.reminderCount;
              obj.references = updatedTemplate.references;
              obj.reminderInterval = updatedTemplate.reminderInterval;
              obj.termsId = updatedTemplate.termsId;
              obj.approvedStatus = updatedTemplate.approvedStatus;
              obj.declinedStatus = updatedTemplate.declinedStatus;
              obj.purgeAfterDays = updatedTemplate.purgeAfterDays;
              obj.notifyUserOfOutcome = updatedTemplate.notifyUserOfOutcome;
              obj.retainHistoryWhenPurge = updatedTemplate.retainHistoryWhenPurge;
              obj.retainCommentsWhenPurge = updatedTemplate.retainCommentsWhenPurge;
              obj.notifyRequesterAfterPurge = updatedTemplate.notifyRequesterAfterPurge;
              obj.notifyRequestedAfterPurge = updatedTemplate.notifyRequestedAfterPurge;
              obj.useCustomAlias = updatedTemplate.useCustomAlias;
              obj.customAliasName = updatedTemplate.customAliasName;
              obj.disableSMSNotifications = updatedTemplate.disableSMSNotifications;
              obj.customSignzyFlows = updatedTemplate.customSignzyFlows;
            }
            this.profileTemplateDialog = false;
          });
        } catch(err) {
          this.$notify({
            type: 'error',
            title: 'Error',
            text: 'Error updating template. Please contact support@planetverify.com',
          });
        }
      } else {
        // CREATING NEW TEMPLATE
        const i = [];
        const n = [];
        const m = [];

        this.profileItemsBase.forEach(el => {
          if (el.include) i.push(el.id);
          if (el.neverArchive) n.push(el.id);
          if (el.mandatory) m.push(el.id);
        });
        this.profileItemsDocs.forEach(el => {
          if (el.include) i.push(el.id);
          if (el.neverArchive) n.push(el.id);
          if (el.mandatory) m.push(el.id);
        });
        this.profileItemsForms.forEach(el => {
          if (el.include) i.push(el.id);
          if (el.neverArchive) n.push(el.id);
        });

        const selectedTemplates = [];
        let docusignEmpty = true;
        this.eSignTemplates.forEach(template => {
          if (template.include) {
            docusignEmpty = false;
            selectedTemplates.push(template.id);
          }
          if (template.neverArchive) n.push(template.id);
        });

        if (!i.length && docusignEmpty) {
          this.$notify({
            type: 'error',
            title: 'Error',
            text: 'Need to select at least one request item',
          });
          return;
        }

        this.customEmailTemplatesList.forEach(emailTemplate => {
          if (emailTemplate.selectedEmailTemplate) {
            this.customEmailTemplates.push({
              templateId: emailTemplate.selectedEmailTemplate,
              type: emailTemplate.type,
            });
          }
        });

        const customSignzyFlows = this.getSelectedSignzyFlows();

        const newTemplate = {
          accountId: this.account.accountId,
          id: this.templateId,
          name: this.templateName,
          reminderCount: this.selectedReminderCount,
          references: this.selectedReferences,
          reminderInterval: this.selectedReminderInterval,
          approvedStatus: this.selectedApprovedAutcome,
          declinedStatus: this.selectedDeclinedAutcome,
          purgeAfterDays: this.selectedApprovedOutcomePurging,
          notifyUserOfOutcome: this.notifyUserOfOutcome,
          retainHistoryWhenPurge: this.retainHistoryWhenPurge,
          retainCommentsWhenPurge: this.retainCommentsWhenPurge,
          notifyRequesterAfterPurge: this.notifyRequesterOfPurge,
          notifyRequestedAfterPurge: this.notifyUserOfPurge,
          useCustomAlias: this.useCustomAlias,
          customAliasName: this.customAliasName,
          disableSMSNotifications: this.disableSMSNotifications,
          selectedItems: i,
          selectedNeverArchive: n,
          selectedMandatory: m,
          customItems: this.customBaseItems,
          customDocuments: this.customDocumentItems,
          eSignTemplates: selectedTemplates,
          customTemplates: this.customFormItems,
          customSignzyFlows,
        }
        if (this.selectedTerms && this.selectedTerms !== 'None') {
          newTemplate.termsId = this.selectedTerms;
        }
        if (this.customEmailTemplates.length) {
          newTemplate.customEmailTemplates = this.customEmailTemplates;
        }

        try {
          await this.$store.dispatch(CREATE_TEMPLATE, newTemplate);
          this.$notify({
            type: 'success',
            title: 'Success',
            text: 'Profile template created',
          });
          this.profileTemplateDialog = false;
        } catch(err) {
          this.$notify({
            type: 'error',
            title: 'Error',
            text: 'Error creating template. Please contact support@planetverify.com',
          });
        }
        setTimeout(() => {
          this.updateProfileTemplates();
        }, 2000);
      }
    },
    addProfileTemplate() {
      // if (!this.limitations.T_CreateTemplate) {
      //   this.featureLimitedModal = true;
      //   return;
      // }
      this.profileTemplateDialog = true;
      if (this.$refs.templateForm) {
        this.$refs.templateForm.resetValidation();
      }
      this.profileItems.forEach(el => {
        el.include = false;
        el.neverArchive = false;
      });
      this.profileItemsBase = this.profileItems.filter(x => x.itemType === 1 );
      this.profileItemsDocs = this.profileItems.filter(x => x.itemType === 2 );
      this.profileItemsForms = this.profileItems.filter(x => x.itemType === 4 && x.name.includes('Medical') );
      this.isEdit = false;
      this.modalTitle = 'New request template';
      this.templateId = uuidv4();
      this.templateName = '';
      this.selectedReminderCount = 1;
      this.selectedReferences = [{ name: 'Reference', ordinal: 0, value: '' }];
      this.selectedReminderInterval = 24;
      this.selectedApprovedAutcome = 6;
      this.selectedDeclinedAutcome = 6;
      this.selectedApprovedOutcomePurging = 0;
      this.selectedTerms = 'None';
      this.useCustomAlias = false;
      this.customAliasName = '';
      this.notifyUserOfOutcome = false;
      this.retainHistoryWhenPurge = false;
      this.retainCommentsWhenPurge = false;
      this.notifyRequesterOfPurge = false;
      this.notifyUserOfPurge = false;
      this.disableSMSNotifications = true;
      this.customEmailTemplates = [];
      this.selected_items = [];
      this.never_archive = [];
      this.customFormItems = [];
      this.customDocumentItems = [];
      this.customBaseItems = [];
      this.customEmailTemplatesList.forEach(t => {
        t.selectedEmailTemplate = 0;
      });
      this.setSignzyFlowSelections([]);
    },
    editProfileTemplate(template) {
      // if (!this.limitations.T_EditTemplate) {
      //   this.featureLimitedModal = true;
      //   return;
      // }
      this.templatePanels = [0];
      this.isEdit = true;
      this.modalTitle = 'Edit Profile Template Settings';
      this.templateId = template.id;
      this.templateName = template.name;
      this.selectedReminderCount = template.reminderCount;
      this.selectedReferences = template.references;
      this.selectedReminderInterval = template.reminderInterval;
      this.selectedApprovedAutcome = template.approvedStatus;
      this.selectedDeclinedAutcome = template.declinedStatus;
      this.selectedApprovedOutcomePurging = template.purgeAfterDays;
      this.selectedTerms = template.termsId === '00000000-0000-0000-0000-000000000000' ? 'None' : template.termsId;
      this.useCustomAlias = template.useCustomAlias;
      this.customAliasName = template.customAliasName;
      this.notifyUserOfOutcome = template.notifyUserOfOutcome;
      this.retainHistoryWhenPurge = template.retainHistoryWhenPurge;
      this.retainCommentsWhenPurge = template.retainCommentsWhenPurge;
      this.notifyRequesterOfPurge = template.notifyRequesterAfterPurge;
      this.notifyUserOfPurge = template.notifyRequestedAfterPurge;
      const templateDisableSMSNotifications =
        template.disableSMSNotifications !== undefined
          ? template.disableSMSNotifications
          : template.DisableSMSNotifications;
      this.disableSMSNotifications = !!templateDisableSMSNotifications;
      this.customEmailTemplates = template.customEmailTemplates;
      this.profileTemplateDialog = true;
      this.customFormItems = [];
      this.customDocumentItems = [];
      this.customBaseItems = [];
      this.setSignzyFlowSelections(template.customSignzyFlows || []);
    },
    copyTemplate(template){
      this.editProfileTemplate(template);
      this.templateId = uuidv4();
      this.templateName = '';
      this.isEdit = false;

      this.profileItems.forEach(el => {
        el.include = false;
        el.neverArchive = false;
      });
      this.profileItemsBase = this.profileItems.filter(x => x.itemType === 1 );
      this.profileItemsDocs = this.profileItems.filter(x => x.itemType === 2 );
      this.profileItemsForms = this.profileItems.filter(x => x.itemType === 4 && x.name.includes('Medical') );

      template.basicItems.forEach(el => {
        var it = this.profileItemsBase.find(_ => _.id === el.id);
        if(it){
          it.include = true;
          it.neverArchive = el.neverArchive;
        }
        else{
          el.include = true;
          this.customBaseItems.push(el);
        }
      });

      template.fileItems.forEach(el => {
        var it = this.profileItemsDocs.find(_ => _.id === el.id);
        if(it){
          it.include = true;
          it.neverArchive = el.neverArchive;
        }
        else{
          el.include = true;
          this.customDocumentItems.push(el);
        }
      });

      template.formItems.forEach(el => {
        var it = this.profileItemsForms.find(_ => _.id === el.id);
        if(it){
          it.include = true;
          it.neverArchive = el.neverArchive;
        }
        else{
          el.include = true;
          if(el.sections){
            el.sections.forEach(sec => {
              sec.id = sec.sectionId;
              if(sec.sectionItems){
                sec.sectionItems.forEach(itm => {
                  itm.id = itm.itemId;
                });
              }
            });
          }
          this.customFormItems.push(el)
        }
      });

      this.setSignzyFlowSelections(template.customSignzyFlows || []);

      this.customEmailTemplates = [];

      this.customEmailTemplatesList.forEach(t => {
        t.selectedEmailTemplate = 0;
      });

      if(template.customEmailTemplates){
        template.customEmailTemplates.forEach(t => {
          var emTemp = this.customEmailTemplatesList.find(x => x.type === t.type);
          if(emTemp){
            emTemp.selectedEmailTemplate = t.templateId;
          }
        });
      }
    },
    confirmDeleteProfileTemplate(template) {
      // if (!this.limitations.T_DeleteTemplate) {
      //   this.featureLimitedModal = true;
      //   return;
      // }
      this.templateToDelete = template;
      this.confirmDeleteTemplateDialog = true;
    },
    async deleteProfileTemplate() {
      try {
        await this.$store.dispatch(DELETE_TEMPLATE, { id: this.templateToDelete.id });
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Profile template deleted',
        });
        this.confirmDeleteTemplateDialog = false;
        this.updateProfileTemplates();
      } catch(err) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Error deleting template. Please contact support@planetverify.com',
        });
        this.confirmDeleteTemplateDialog = false;
      }
    },
  },
  async mounted() {
    await this.$store.dispatch(CHECK_ORGANIZATIONS);
    await this.getCustomEmailTemplates();
    await this.loadSignzyFlows();
    await this.updateprofileItemsList();
    await this.updateProfileTemplates();
  },
}
</script>

<style>
.v-expansion-panels.new-template-options {
  border-radius: 0;
}
.v-expansion-panels.new-template-options .v-expansion-panel::before {
  box-shadow: none;
}
.v-expansion-panels.new-template-options .v-expansion-panel:not(:first-child)::after {
  border-top: none;
}
.v-expansion-panels.new-template-options .v-expansion-panel-header {
  padding-left: 0;
  padding-right: 0;
  border-bottom: 1px solid rgba(0,0,0,.12);
}
.v-expansion-panels.new-template-options .v-expansion-panel-content__wrap {
  padding-left: 0;
  padding-right: 0;
}
</style>
